import React, {useEffect} from "react"
import {withPrefix} from "gatsby"
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ"

import UNIVERSAL_HEADER_DATA from "../data/en/header"
import HERO_BANNER_DATA from "../data/en/herobanner"
import FIRST_CAROUSEL_DATA from "../data/en/1Carousel"
import SECOND_CAROUSEL_DATA from "../data/en/2Carousel"
import THIRD_CAROUSEL_DATA from "../data/en/3Carousel"
import FAQ_DATA from "../data/en/faq"
import Layout from "../components/layout"
import "../css/main.css"
import {fireGtmEvent} from "../utils/functions"

const ContentWrapper = styled.div`
  max-width: 625px;
  margin-bottom: 24px;

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0 auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0 auto 48px;
  }
`

const TitleWrapper = styled.div`
  margin-bottom: 3em;

  #subtitle {
    font-size: 1.2rem;
    line-height: 2.2rem;
  }

a {
    color: rgb(220, 50, 36);
    text-decoration: none;
  }
  @media only screen and (max-width: 720px){
    width: 90%;
    margin: 2em auto;

    #title {
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 10px;
    }

    #subtitle {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }
`

const TextContentWrapper = styled.div`
  width: 90%;
  margin: 0 16px 24px;

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0 auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0 auto 48px;
  }
`


const IndexPage = () => {
    const updateLocale = (obj) => {
        window.location.href = withPrefix(obj.detail)
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener("uhfLocaleChange", updateLocale)
        }
    }, [])

    return (
        <Layout title="Super Outlets with Great Value | airasia Certified Super"
                description="Get more value for your money with trusted & recommended merchants in the airasia Super App. Choose Certified Super establishments for Food, Hotels and more!"
                keywords="airasia super, airasia certified super, airasia super badge, airasia certified super hotels, airasia certified super food, airasia certified super outlets, certified super, certified super badge, certified super food, certified super hotels, certified super reviews, certified super outlets"
                bannerData={HERO_BANNER_DATA}
                headerData={UNIVERSAL_HEADER_DATA}
        >

            <ContentWrapper>
                <TitleWrapper>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h1"
                        customProperties={{id: 'title'}}
                    >
                        Can't decide? Let the Certified Super badge guide you
                    </Title>
                    <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        theme="AIRASIA_CLASSIC"
                        type="h2"
                        customProperties={{id: 'subtitle'}}
                    >
                        Too much choice can be overwhelming, even on the airasia Super App. That's why we created the Certified Super badge for trusted, well-loved establishments that we heartily recommend. For great value any day, just look for the badge.

                    </Title>
                </TitleWrapper>
                
            </ContentWrapper>
            
            <ContentWrapper>
            <div style={{position: "relative", width: "89%", overflow: "hidden", paddingTop: "50%",left: "5%"}}>
                        <iframe src="https://www.youtube.com/embed/T3V2oCY4PeA?controls=0&rel=0" title="Youtube Player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" style={{position: "absolute", top: "0", eft: "0", bottom: "0", right: "0", width: "100%", height: "100%", border: "none"}}></iframe></div>
            </ContentWrapper>
            
            <ContentWrapper>
                <Carousel
                    accessible
                    allowLocaleFormat={true}
                    data={FIRST_CAROUSEL_DATA.data}
                    heading={FIRST_CAROUSEL_DATA.heading}
                    isHideFooter={false}
                    isLoading={false}
                    templateType="productCard"
                />
            </ContentWrapper>
            <ContentWrapper>
                <Carousel
                    accessible
                    allowLocaleFormat={true}
                    data={SECOND_CAROUSEL_DATA.data}
                    heading={SECOND_CAROUSEL_DATA.heading}
                    isHideFooter={false}
                    isLoading={false}
                    templateType="productCard"
                    fireGtm={fireGtmEvent}
                    gtmConsumerName="Grocer Value Pack"
                />
            </ContentWrapper>
            <ContentWrapper>
                 <Carousel
                     accessible
                     allowLocaleFormat={true}
                     data={THIRD_CAROUSEL_DATA.data}
                     heading={THIRD_CAROUSEL_DATA.heading}
                     isHideFooter={false}
                     isLoading={false}
                     templateType="productCard"
                     fireGtm={fireGtmEvent}
                     gtmConsumerName="Grocer Value Pack"
                 />
             </ContentWrapper>
            <TextContentWrapper>
                <FAQ
                    titleMarginBottom="normal"
                    titleType="h3"
                    title=""
                    data={FAQ_DATA}
                />
            </TextContentWrapper>
        </Layout>
    )
}
export default IndexPage
